import React, { useReducer, Dispatch, createContext, ReactNode } from 'react'
import { getReferrer, getUserFirstAttribution } from 'utils'

import { BoardingAction, boardingReducer } from './reducer'

export type BoardingState = {
  user: {
    email?: string
    displayName?: string
    password?: string
    photoURL?: string
    position?: string
    referrer?: string
    firstAttribution?: Record<string, unknown>
    acceptedPrivacyPolicy: boolean
    cacheKey?: string
    emailHandler?: string
  }
  organization: {
    name?: string
    domain?: string
    photoURL?: string
    authDomains?: string
    size?: number
    goal?: string
    remoteStance?: string
    marketingAttribution?: string
    membersCanAutoJoinByDomain: boolean
    isPopularDomain: false
  }
}

const defaultBoardingState: BoardingState = {
  user: {
    referrer: getReferrer(),
    firstAttribution: getUserFirstAttribution(),
    acceptedPrivacyPolicy: false,
  },
  organization: {
    membersCanAutoJoinByDomain: true,
    isPopularDomain: false,
  },
}

// eslint-disable-next-line react-refresh/only-export-components
export const boardingStateContext =
  createContext<BoardingState>(defaultBoardingState)

// eslint-disable-next-line react-refresh/only-export-components
export const boardingDispatchContext = createContext<Dispatch<BoardingAction>>(
  () => {}
)

type BoardingProviderProps = { children: ReactNode }

export function BoardingProvider({ children }: BoardingProviderProps) {
  const [state, dispatch] = useReducer(boardingReducer, defaultBoardingState)

  return (
    <boardingStateContext.Provider value={state}>
      <boardingDispatchContext.Provider value={dispatch}>
        {children}
      </boardingDispatchContext.Provider>
    </boardingStateContext.Provider>
  )
}
